import { Unit } from "../UnitSelect";

export function localizeMetric(metric: { sqm: number; sqft: number }, unit: Unit): number {
  return unit === Unit.sqm ? metric.sqm : metric.sqft;
}
